import React, { useEffect, useState } from 'react';
import errorGraphic from '../../assets/images/error-boundary-graphic.svg';

interface CustomErrorBoundaryProps {
  children: React.ReactElement;
}

function CustomErrorBoundary({
  children
}: Readonly<CustomErrorBoundaryProps>): React.ReactElement {
  const [hasError, setHasError] = useState<boolean>(false);

  useEffect(() => {
    const errorListener = (): void => {
      setHasError(true);
    };

    globalThis.addEventListener('error', errorListener);

    return () => {
      globalThis.removeEventListener('error', errorListener);
    };
  }, []);

  if (hasError) {
    return (
      <div className='flex flex-col items-center justify-center py-24 px-4 text-center max-w-md mx-auto'>
        <h1 className='text-2xl font-semibold text-foreground mb-6'>
          Sorry, something went wrong.
        </h1>
        <img
          src={errorGraphic}
          alt=''
          role='presentation'
          className='h-52 mb-6'
        />
        <p className='text-sm text-muted-foreground'>
          Please try again. If the problem continues, contact support at{' '}
          <a href='mailto:support@japeto.ai' className='underline'>
            support@japeto.ai
          </a>
        </p>
      </div>
    );
  }

  return children;
}

export default CustomErrorBoundary;
